/**
 * Préférences d'affichage ↔ compte : le profil l'emporte s'il contient des choix ; sinon les choix
 * faits dans ce navigateur sont envoyés au compte.
 */

import { getFormatPreferences, setFormatPreferences, type FormatPreferences } from '../../../shared/format'
import { getMe, updateMe } from '../services/userApi'
import { isAuthenticated } from './tokenStorage'

let username: string | null = null

export async function pullFormatPreferences(): Promise<void> {
  if (!isAuthenticated()) {
    username = null
    return
  }
  const me = await getMe()
  username = me.username
  const remote = me.format_preferences ?? {}
  if (Object.keys(remote).length) setFormatPreferences(remote)
  else if (Object.keys(getFormatPreferences()).length) await updateMe({ format_preferences: getFormatPreferences() }, me.username)
}

/** Applique tout de suite, puis enregistre dans le compte si l'utilisateur est connecté. */
export async function saveFormatPreferences(next: FormatPreferences): Promise<void> {
  setFormatPreferences(next)
  if (!isAuthenticated()) return
  if (!username) username = (await getMe()).username
  await updateMe({ format_preferences: getFormatPreferences() }, username)
}
